import { ControlInstructionParser } from '@utils/control-instruction-parser';
import { tryExtractInstruction } from '@utils/regex';
import { Element } from 'src/openapi-client/model/element';
import { CellWidgetControlInstructionFunctions } from './types';

class CellWidgetClassParser {
  private readonly constrolInstructionParser: ControlInstructionParser<CellWidgetControlInstructionFunctions>;
  private readonly classList: Set<string> = new Set();

  constructor() {
    this.constrolInstructionParser = new ControlInstructionParser({
      header: this.ciHeader,
    });
  }

  public parseClasses(cellName: string): string[] {
    this.classList.clear();

    if (this.checkForHardcodedCellNames(cellName)) {
      return Array.from(this.classList.values());
    }

    const instructions: string | null = tryExtractInstruction(cellName);

    if (!instructions) {
      // No control instructions
      return ['sd-paragraph'];
    }

    this.constrolInstructionParser.parseControlInstructions(instructions, { cellName });

    return Array.from(this.classList.values());
  }

  private checkForHardcodedCellNames(cellName: string): boolean {
    if (cellName === 'Header') {
      this.classList.add('sd-headline');
      this.classList.add('sd-headline--size-3xl');
      return true;
    }

    return false;
  }

  private readonly ciHeader = (): void => {
    this.classList.add('sd-leadtext');
  };
}

const parser = new CellWidgetClassParser();

export function getCellWidgetClasses(element: Element): string[] {
  return parser.parseClasses(element.name);
}
